import {useQuery} from 'react-query';
import getMyStoreInputGroups, {
  IGetMyStoreInputGroupsParams,
} from './getMyStoreInputGroups';

interface IUseGetMyStoreInputGroupsProps extends IGetMyStoreInputGroupsParams {
  enabled?: boolean;
}

const useGetMyStoreInputGroups = ({
  enabled = true,
  only_lendtech,
  status,
}: IUseGetMyStoreInputGroupsProps) => {
  const {data, isLoading, refetch} = useQuery({
    queryKey: ['get-store-input-groups', status, only_lendtech],
    queryFn: () => getMyStoreInputGroups({only_lendtech, status}),
    enabled: enabled,
  });

  return {data, isLoading, refetch};
};

export default useGetMyStoreInputGroups;
